import { AloftPrice, schAlertType } from '@aloft/toolkit-shared';

import { AlertDefinition } from '../../types.ts';
import { getDepreciatedCostPageRoute } from '../utils/getDepreciatedCostPageRoute.ts';

export const negativeSiteValue: AlertDefinition = ({ compSequence, order, siteValues }) => {
  const [propertyID, siteValue] =
    Object.entries(siteValues).find(([_propertyID, sv]) => !sv || sv.lt(AloftPrice.zero)) ?? [];

  if (!propertyID || !siteValue) return undefined;

  const propertyName =
    propertyID === 'subject'
      ? 'Subject'
      : `Comparable ${compSequence.findIndex((id) => id === propertyID) + 1}`;

  return {
    type: schAlertType.enum.negativeSiteValue,
    status: 'active',
    severity: 'error',
    message: `${propertyName} has a negative Site Value (${siteValue.toString()}).`,
    propertyID,
    fixingInfo: {
      tips: 'Tips: Adjust the Cost Quality or Effective Age sliders to accurately reflect the observed construction quality and remaining utility of the property,',
      pairedCostRouteItem: getDepreciatedCostPageRoute(order),
      fixingMethod: ['comment', 'action'],
      commentAlwaysRequired: false,
    },
    triggers: [],
  };
};
